import DetailsPage from'@24i/nxg-sdk-smartott/src/pages/details/[type]/[id]';

export default DetailsPage;